import { memo, type ReactNode } from 'react';

import { SectionError } from './section-error';
import { SentryErrorBoundary } from './sentry-error-boundary';

type Props = {
  sectionHeading?: JSX.Element;
  sentryComponentId: string;
  children: ReactNode;
};

export const SectionErrorBoundary = memo((props: Props) => {
  return (
    <SentryErrorBoundary
      componentId={`${props.sentryComponentId}-section-error-boundary`}
      renderError={({ sentryEventId }) => {
        return (
          <SectionError
            sectionHeading={props.sectionHeading}
            sentryEventId={sentryEventId || undefined}
          />
        );
      }}
    >
      {props.children}
    </SentryErrorBoundary>
  );
});
